import axios from "./api";
class RequirementSubmissionService {
  getAll() {
    return axios.get(`/requirementSubmissions`);
  }
  get(id) {
    return axios.get(`/requirementSubmissions/${id}`);
  }
  create(data) {
    return axios.post(`/requirementSubmissions`, data);
  }
  update(id, data) {
    return axios.put(`/requirementSubmissions/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/requirementSubmissions/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RequirementSubmissionService();
